<template>
  <v-container fluid class="px-4 pa-md-8">
    <v-list flat dense class>
      <v-list-item-group class>
        <v-list-item class="px-0" @click="back()">
          <v-list-item-icon :disabled="loadingRest" class>
            <v-icon class="headline" color="black">mdi-arrow-left</v-icon>
          </v-list-item-icon>
          <v-list-item-content class="py-0 my-0">
            <v-list-item-title
              class="headline font-weight-bold py-2"
            >{{$t('pedido.totem.carrito.modo.btn.domicilio')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
    <v-row no-gutters>
      <v-col id="dirmapa">
        <input-localizacion
          modo="domicilio"
          @update="addressExists"
          v-if="listadoRestaurantesPosibles.length < 1"
        />
        <!-- input para mostrar sobre lo que está pidiendo en listado-->
        <v-row justify="center" class="md-10 lg-8 xl-6" v-else>
          <v-col>
            <v-text-field
              readonly
              solo
              outlined
              shaped
              flat
              rounded
              filled
              single-line
              hint="Dirección de reparto"
              persistent-hint
              :value="addressObjectFormated"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col class="py-0" xs="12" offset-xs="0" sm="10" offset-sm="1" md="8" offset-md="2">
            <h3
              v-if="listadoRestaurantesPosibles.length < 1"
              class="mb-3"
            >{{$t('pedido.elegirModo.titulo.domicilio.indique')}}</h3>
          </v-col>
        </v-row>

        <div v-if="loadingDireccionNavegador">
          <v-row>
            <v-col class="py-0" xs="12" offset-xs="0" sm="10" offset-sm="1" md="8" offset-md="2">
              <v-sheet v-for="(item,i) in 2" class="w-100" :key="i">
                <v-skeleton-loader type="list-item-avatar-two-line"></v-skeleton-loader>
              </v-sheet>
            </v-col>
          </v-row>
        </div>
        <div v-else>
          <!-- Direccion por geolocalizacion -->
          <v-row
            v-if="!geolocalizacionEnLibreta && listadoRestaurantesPosibles.length < 1 && !loadingRest"
          >
            <v-col
              class="py-0"
              xs="12"
              offset-xs="0"
              sm="10"
              offset-sm="1"
              md="8"
              offset-md="2"
              v-if="mostrarDirNavegador"
            >
              <v-hover
                v-if="Object.entries(direccionNavegador).length > 0 && !loadingDireccionNavegador"
                v-slot:default="{ hover }"
              >
                <v-card @click.stop="pedir(direccionNavegador)" elevation="0" tile class="w-100">
                  <direccion-card v-bind:obj="direccionNavegador" />
                </v-card>
              </v-hover>
              <v-hover v-else v-slot:default="{ hover }">
                <v-card
                  @click.stop="cargarDireccionNavegador()"
                  elevation="0"
                  :color="hover ? 'grey lighten-4' : 'transparent'"
                  tile
                  class="w-100"
                >
                  <v-row no-gutters>
                    <v-list class="pa-0 ma-0 w-100">
                      <v-list-item class="py-4">
                        <v-list-item-icon>
                          <v-icon class="display-1 headline" color="black">mdi-near-me</v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                          <v-list-item-title>{{$t('pedido.totem.carrito.modo.domicilio.listItem.geolocalizar.title')}}</v-list-item-title>
                          <v-list-item-subtitle>{{$t('pedido.totem.carrito.modo.domicilio.listItem.geolocalizar.subtitle')}}</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider></v-divider>
                    </v-list>
                  </v-row>
                </v-card>
              </v-hover>
            </v-col>
          </v-row>

          <!-- Direccion de caché -->
          <v-row v-if="condicionCache">
            <v-col class="py-0" xs="12" offset-xs="0" sm="10" offset-sm="1" md="8" offset-md="2">
              <v-hover v-slot:default="{ hover }">
                <v-card
                  @click.stop="pedir(direccionCache)"
                  elevation="0"
                  :color="hover ? 'grey lighten-4' : 'transparent'"
                  tile
                  class="w-100"
                >
                  <direccion-card v-bind:obj="direccionCache" />
                </v-card>
              </v-hover>
            </v-col>
          </v-row>
          <!-- direcciones de la base de datos -->
          <v-row v-if="isLogged  && listadoRestaurantesPosibles.length < 1 && !loadingRest">
            <v-col
              class="py-0"
              v-for="(dir) in direccionesFiltradas"
              :key="dir.id_direccion"
              xs="12"
              offset-xs="0"
              sm="10"
              offset-sm="1"
              md="8"
              offset-md="2"
            >
              <v-hover v-slot:default="{ hover }">
                <v-card
                  @click.stop="pedir(dir)"
                  elevation="0"
                  :color="hover ? 'grey lighten-4' : 'transparent'"
                  tile
                  class="w-100"
                >
                  <direccion-card v-bind:obj="dir" />
                </v-card>
              </v-hover>
            </v-col>
          </v-row>
        </div>

        <!-- Despliegue de restaurantes -->
        <v-row v-if="loadingRest ">
          <v-col class="pb-0" cols="12" sm="6" md="4" v-for="n in 6" :key="n">
            <v-sheet tile>
              <v-skeleton-loader class="mx-auto pa-3" max-width="100%" type="image"></v-skeleton-loader>

              <v-skeleton-loader class="ml-3" type="heading"></v-skeleton-loader>
              <v-skeleton-loader type="actions"></v-skeleton-loader>
            </v-sheet>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col class="pa-0" cols="12">
            <h2
              v-if="listadoRestaurantesPosibles.length > 0"
              class="mb-3 px-3"
            >{{$t('pedido.elegirModo.titulo.domicilio.elijaRestaurante')}}</h2>
          </v-col>

          <v-col
            cols="12"
            sm="6"
            md="4"
            v-for="(restaurant, index) in listadoRestaurantesPosibles"
            :key="index"
          >
            <restaurant-card v-bind:obj="restaurant" />
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-overlay :value="loadingDialog" opacity="0">
      <v-container class="d-flex align-center justify-center flex-column">
        <h1 class="text--grey grey--text text--darken-4 mb-10">Localizando...</h1>

        <v-progress-circular size="50" width="8" indeterminate color="grey darken-4"></v-progress-circular>
      </v-container>
    </v-overlay>
  </v-container>
</template>

<script>
/* eslint handle-callback-err: "warn" */
import restaurantCard from "@/components/Pedidos/pedir_restaurantCard.vue";
import direccionCard from "@/components/Pedidos/pedir_direccionCard.vue";
import inputLocalizacion from "@/components/Pedidos/pedir_inputLocalizacion.vue";
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  components: {
    direccionCard,
    restaurantCard,
    inputLocalizacion
  },
  data() {
    return {
      mostrarAddDireccion: true,
      showRestaurants: false,
      geolocalizacionEnLibreta: false
    };
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      isLogged: state => state.auth.isLogged,
      isSafari: state => state.app.isSafari,
      addressObject: state => state.pedido.addressObject,
      coordenadas: state => state.pedido.navigatorLocation,
      distanciaMinima: state => state.direcciones.distanciaMinima,
      mostrarDirNavegador: state => state.direcciones.mostrarDirNavegador,
      confirmDialog: state => state.direcciones.confirmDialog,
      loadingDireccionNavegador: state =>
        state.direcciones.loadingDireccionNavegador,
      mostrarDirCache: state => state.direcciones.mostrarDirCache,
      restaurantesPosibles: state => state.restaurante.restaurantesPosibles,
      listadoRestNegMix: state => state.restaurante.listadoRestNegMix,
      dirCacheFormated: state => state.direcciones.direccionCache.formated
    }),
    ...mapGetters({
      direccionCache: "direcciones/direccionCacheFormateada"
      // listadoRestaurantesPosibles: "restaurante/filtradoRestaurantesDomicilio"
    }),
    addressObjectFormated() {
      return this.addressObject.formated;
    },
    dialogDireccion: {
      get() {
        return this.$store.state.pedido.dialogDireccion;
      },
      set(value) {
        this.$store.commit("pedido/setDialogDireccion", value);
      }
    },
    loadingRest: {
      get() {
        return this.$store.state.restaurante.loadingRest;
      },
      set(value) {
        this.$store.commit("restaurante/setLoadingRest", value);
      }
    },
    listadoRestaurantesPosibles: {
      get() {
        return this.$store.state.restaurante.restaurantesPosibles;
      },
      set(v) {
        this.$store.commit("restaurante/setRestaurantesPosibles", v);
      }
    },
    // listadoRestaurantesPosibles() {
    // 	var p = this.restaurantesPosibles;
    // 	var a = this.listadoRestNegMix;
    // 	var res = [];

    // 	if (Array.isArray(p) && Array.isArray(a)) {
    // 		p.forEach(pAux => {
    // 			let found = a.find(e => {
    // 				return e.id == pAux.id;
    // 			});
    // 			if (found) res.push(found);
    // 		});
    // 	}

    // 	this.$store.dispatch("restaurante/reorderRestaurants", res)
    // 	.then(data => {
    // 		return data;
    // 	});

    // 	return res;
    // },
    direccionNavegador: {
      get() {
        return this.$store.state.direcciones.direccionNavegador
          ? this.$store.state.direcciones.direccionNavegador
          : null;
      },
      set(value) {
        this.$store.commit("direcciones/setDireccionNavegador", value);
      }
    },
    direcciones: function() {
      return this.user && this.user.direcciones ? this.user.direcciones : [];
    },
    direccionesFiltradas: function() {
      let _vue = this;
      let res = [];
      res = this.direcciones;

      res.filter(dir => delete dir["cacheada"]);

      res = res.sort(function(a, b) {
        return b.lastUse.seconds - a.lastUse.seconds;
      });

      return res;
    },
    condicionCache: function() {
      let cond1 = Object.keys(this.direccionCache).length > 1; //Debe no estar vacía
      let cond2 = this.listadoRestaurantesPosibles.length < 1; //Debe ser vinculable a algun restaurante
      let cond3 = !this.loadingRest; //No debe estar cargando
      let cond4 = this.mostrarDirCache; //Debe de permitirse mostrarse desde store
      let cond5 = this.direccionCache.cacheada; //no debe ser de recoger porque puede ser incompleta

      return cond1 && cond2 && cond3 && cond4 && cond5;
    },
    loadingDialog: {
      get() {
        return this.$store.state.pedido.loadingDialog;
      },
      set(value) {
        this.$store.commit("pedido/setLoadingDialog", value);
      }
    }
  },
  methods: {
    ...mapActions({
      elegirRestaurante: "pedido/elegirRestaurante",
      cargarDireccionNavegador: "direcciones/cargarDireccionNavegador",
      getDirecciones: "direcciones/getDirecciones",
      openDialogDireccion: "direcciones/openDialogDireccion",
      geocodeAddress: "direcciones/geocodeInput",
      loadAndOrderRestaurants: "direcciones/loadAndOrderRestaurants",
      pedirADireccion: "direcciones/pedirADireccion"
    }),
    addressExists(data) {
      this.showRestaurants = data;
    },
    pedir(dir) {
      let payload = {};
      payload.dir = dir;
      this.pedirADireccion(payload);
    },
    back() {
      if (this.listadoRestaurantesPosibles.length > 0) {
        this.$store.commit("restaurante/setRestaurantesPosibles", []);
      } else {
        this.$store.commit("snackbar/reset");
        this.$router.push({
          path: "/pedir"
        });
      }
    },
    setModo() {
      this.$store.commit("pedido/setModo", "domicilio");
    }
    // openDialogDireccion(addr) {
    // 	let _vue = this;

    // 	this.$store.commit("pedido/setAddressObjectSinFiltro", addr);
    // 	this.$store.commit(
    // 		"direcciones/setAddressOnOpenDialog",
    // 		_vue.addressObject
    // 	);
    // 	this.dialogDireccion = true;
    // }
  },
  mounted() {
    // let _vue = this;
    this.setModo();
    // this.$store.commit("restaurante/resetRestaurante");
  },
  watch: {},
  updated() {},
  destroyed() {}
};
</script>
<style scoped>
.loadingLayer {
  position: absolute;
  left: 0px;
  width: 100vw;
  background-color: #ffffff82;
  z-index: 2;
}
.w-100 {
  width: 100%;
}
.border {
  border: 1px solid #000;
}
</style>